import { Card, Col, Row } from "reactstrap";
import MutualFriends from "../../common/MutualFriends";
import ActivityFeed from "../../common/ActivityFeed";
import { dynamicImage } from "../../../../../utils";
import { UserPosts } from "../../../../../data/applications/SocialApp";
import MyProfile from "../../common/myProfile";
import UserPost from "./userPost";
import ProfileInfoCard from "../../common/rightBar/ProfileInfoCard";
import FollowerCard from "../../common/rightBar/FollowerCard";
import FollowingsCard from "../../common/rightBar/FollowingsCard";
import LatestPhotos from "../../common/rightBar/LatestPhotos";
import FriendsCard from "../../common/rightBar/FriendsCard";
import { Image } from "../../../../../coreComponents/Image";

const Timeline = () => {
  return (
    <Row>
      <Col className="box-col-4 xl-40" md="5" xl="3" lg="12">
        <div className="default-according style-1 faq-accordion">
          <MyProfile />
          <MutualFriends />
          <ActivityFeed />
        </div>
      </Col>
      <Col className="box-col-8e xl-60" md="7" xl="6" lg="12">
        <Row>
          {UserPosts.map((item) => (
            <Col sm="12" key={item.id}>
              <UserPost item={item} />
            </Col>
          ))}
        </Row>
      </Col>
      <Col className="box-col-12 xl-100" xl="3">
        <div className="default-according style-1 faq-accordion job-accordion">
          <Row>
            <Col xl="12" className="xl-50 box-col-6">
              <ProfileInfoCard />
            </Col>
            <Col xl="12" className="xl-50 box-col-6">
              <FollowerCard />
            </Col>
            <Col xl="12" className="xl-50 box-col-6">
              <FollowingsCard />
            </Col>
            <Col xl="12" className="xl-50 box-col-6">
              <LatestPhotos />
            </Col>
            <Col xl="12" className="xl-50 box-col-6">
              <FriendsCard />
            </Col>
            <Col xl="12" className="xl-50 box-col-6">
              <Card>
                <Image className="img-fluid rounded-3 w-100" src={dynamicImage(`social-app/timeline-4.png`)} alt="timeline" />
              </Card>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default Timeline;
